<template>
  <div>
    <!-- Documents table -->
    <div class="card pagination-margin"
         qid="documents-section"
         id="update_documents"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="measure-table-title" v-if="!showOnTask">
                {{ $t('maintenance.third_parties.documents.title') }}
              </h5>

              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_documents')"
                >
                  <UpdateSingleTaskModal
                      :task="myTasks[0]"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_documents')">
                  <GuideButton :guide="getGuide('update_documents')"></GuideButton>
                </span>
              </span>

            </div>

          </div>
          <div class="col-sm-6 text-right">
            <span class="btn btn-success float-right cursor-pointer"
                  @click="showCreateDocumentModal()"
                  qid="retention-rule-create-button"
                  v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], object) && (!getClient.parent || (getClient.parent && object.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.third_parties.documents.add_new') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
          <tr>
            <th scope="col"
                class="cursor-pointer"
                @click="selectSort('name')"
                qid="sort-s-name"
            >
              {{ $t('activities.measures.table.name') }}
              <span class="ml-2">
                <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
              </span>
            </th>
            <th scope="col">
              {{ $t('maintenance.policies.documents.version') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.category') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.start_date') }}
            </th>
            <th scope="col" class="text-center">
              {{ $t('maintenance.policies.documents.published') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.policies.documents.draft') }}
            </th>
            <th width="180"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(object, index) in documentTableItems">
              <td>
                <span
                    @click="openViewDocumentListModal(object)"
                    class="btn btn-link btn-sm text-left cursor-pointer"
                    v-if="object && object.latest_publish_version && object.latest_publish_version.name"
                >
                    {{ object.latest_publish_version.name }}
                </span>
              </td>
              <td>
                <span v-if="object && object.latest_publish_version" class="text-normal">
                  {{ object.latest_publish_version.version }}
                </span>
              </td>
              <td>
                <span v-if="object && object.latest_publish_version && object.latest_publish_version.category" class="text-normal">
                  <font-awesome-icon icon="shapes"/>
                  {{ object.latest_publish_version.category }}
                </span>
              </td>
              <td>
                <span v-if="object && object.latest_publish_version && object.latest_publish_version.start_date && object.latest_publish_version.status == 'published'" class="text-normal">
                  {{ object.latest_publish_version.start_date | formatDate }}
                </span>
                <span v-else class="text-normal">
                  {{ $t('system.n_a') }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="object && object.latest_publish_version && object.latest_publish_version.status == 'published'">
                  <font-awesome-icon icon="check-circle" class="icon-success" style="background:white;border-radius:50%;"/>
                </span>
              </td>
              <td>
                <span v-if="object && object.latest_version && object.latest_version.status && object.latest_version.status == 'edit_mode'" class="text-normal">
                  <font-awesome-icon icon="info-circle" class="icon-info" style="background:white;border-radius:50%;"/>
                  {{ $t('system.' + $options.filters.slugify(object.latest_version.status)) }}
                </span>
                <span v-if="object && object.latest_version && object.latest_version.status && object.latest_version.status == 'ready_to_publish'" class="text-normal">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-9"/>
                  {{ $t('system.' + $options.filters.slugify(object.latest_version.status)) }}
                </span>
              </td>
              <td class="text-right">
                <span v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], policy) && (!getClient.parent || (getClient.parent && policy.partition))"
                      class="btn btn-edit"
                      qid="edit-p-modal"
                      @click="openViewDocumentListModal(object)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span
                    @click="openDocument(object.latest_publish_version)"
                    class="btn btn-view cursor-pointer"
                    v-if="object && object.latest_publish_version"
                    :disabled="object.latest_publish_version && (!object.latest_publish_version.master || object.latest_publish_version.status != 'published')"
                >
                  <font-awesome-icon :icon="['fab', 'readme']"/>
                </span>
                <span class="btn btn-delete cursor-pointer"
                      qid="delete-document-modal"
                      @click="showDocumentConfirmDeleteModal(object)"
                      v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], policy) && (!getClient.parent || (getClient.parent && policy.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!measureLoading && !documentTableItems.length" qid="no-results-row-rr" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
            <tr v-if="measureLoading" qid="no-results-row-rr" class="text-center">
              <td colspan="10">
                <div class="mt-2 mb-4">
                  <div class="swing-container">
                    <div class="swing">
                      <div class="swing-l"></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div class="swing-r"></div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <div class="card-body">
        <div class="pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                  v-model="perPage"
                  :options="perPageOptions"
                  track-by="value"
                  label="value"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="create-org-form-organization-level"
                  @select="perPageChanged"
                  :placeholder="selectedPerPage"
                  @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>


    <!-- Delete document modal template -->
    <b-modal ref="delete-document" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-document-title">
          {{ $t('activities.measures.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.measures.delete.description') }}
        <span v-if="itemToDelete">{{ itemToDelete.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('activities.measures.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideDocumentConfirmDeleteModal"
                  qid="delete-document-cancel-button"
        >
          {{ $t('activities.measures.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteDocument(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-document-submit-button"
        >
          {{ $t('activities.measures.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Add new document -->
    <b-modal ref="add-document" hide-footer @hide="hideCreateDocumentModal" size="lg">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('maintenance.third_parties.documents.add_modal_title')}}
        </h4>
      </div>
      <b-alert v-if="add_error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ add_error }}
      </b-alert>
      <b-form @submit="formSubmit" qid="create-ac-form">
        <div class="form-container">
          <div class="row">
            <div class="col-sm-12">
              <b-form-group>
                <label qid="create-tp-name-label">
                  {{ $t('maintenance.third_parties.create.name_label') }}
                </label>
                <span class="text-red">*</span>
                <b-form-input
                  qid="create-tp-form-name"
                  type="text"
                  v-model="form.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.third_parties.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group :class="{'multiselect--show-input': categoryInput.length}">
                <label qid="create-do-type-label">
                  {{ $t('maintenance.third_parties.documents.category') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="selectedCategory"
                    :options="categoryItems"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('maintenance.data_objects.create.category_placeholder')"
                    label="category"
                    track-by="category"
                    :preserveSearch="true"
                    @search-change="handleCategoryInput"
                    qid="create-do-form-category"
                >
                  <template slot="noResult" slot-scope="props">
                    {{ $t('maintenance.data_objects.create.category_no_results') }}
                  </template>
                </multiselect>
              </b-form-group>

              <b-form-group class="mt-3">
                <label qid="create-tp-attachments-label">
                  {{ $t('maintenance.policies.create.attachments_and_links') }}
                </label>
                <span class="text-red">*</span>
                <br>

                <div class="form-control auto-height mt-1">
                  <div class="text-muted" v-if="(getFiles && !getFiles.length) && (form.links && !form.links.length)">
                    {{ $t('maintenance.policies.documents.no_attachments') }}
                  </div>
                  <div v-for="(file, index) in getFiles" class="mt-1 mb-1">
                    <div class="row">
                      <div class="col-sm-1">
                        <font-awesome-icon
                          icon="star"
                          :class="{'color-yellow': file.master, 'text-light': !file.master}"
                          class="cursor-pointer"
                          @click="setMaster(index)"
                          v-if="file.type == 'application/pdf'"
                        />
                      </div>
                      <div class="col-sm-11">
                        <span class="">{{ file.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-for="(link, index) in form.links">
                    <div class="row">
                      <div class="col-sm-1">
                        <font-awesome-icon
                          icon="star"
                          :class="{'color-yellow': link.master, 'text-light': !link.master}"
                          class="cursor-pointer"
                          @click="setLinkMaster(index)"
                        />
                      </div>
                      <div class="col-sm-11">
                        <span class="float-right text-muted cursor-pointer"
                              @click="removeLinkItem(index)"
                              qid="create-tp-link-remove"
                        >
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                        <a :href="link.url" target="_blank" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="mt-1">
                  <span class="text-light">
                    {{ $t('maintenance.policies.create.attachments_tip') }}
                  </span>
                </div>
                <br>

                <div class="mt-1">
                  <span class="btn btn-link cursor-pointer"
                        @click="showInput = true"
                        qid="add-another-link"
                  >
                    <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
                  </span>
                  <label class="ml-3 mb-0 btn btn-link cursor-pointer" qid="create-tp-attachments-button">
                    <input type="file"
                           name="fileupload"
                           value="fileupload"
                           multiple
                           id="file"
                           @change="onFileChange"
                           @click="resetFile"
                    >
                    <span>
                      <font-awesome-icon icon="plus"/>
                      {{ $t('system.add_attachment') }}
                    </span>
                  </label>
                </div>
              </b-form-group>

              <b-form-group>
                <div v-if="showInput">
                  <label class="mt-2">{{ $t('system.link') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLink"
                    :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                    qid="create-p-links"
                  ></b-form-input>
                  <label class="mt-2">{{ $t('table.name') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLinkName"
                    :placeholder="inputLink ? inputLink : $t('table.name')"
                    qid="create-p-links"
                  ></b-form-input>

                  <span class="btn btn-success cursor-pointer float-right mt-2 mr-0"
                        @click="handleLink"
                        qid="create-tp-add-link"
                  >
                    {{ $t('system.save') }}
                  </span>
                </div>
              </b-form-group>

              <b-form-group>
                <label qid="create-do-contact-label">
                  {{ $t('maintenance.policies.documents.status_label') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="form.status"
                    :options="statusItems"
                    :placeholder="$t('maintenance.policies.documents.status_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-do-form-classification"
                >
                  <template slot="option" slot-scope="props">
                    <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'published'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'edit_mode'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle" class="risk-9" v-if="props.option.value == 'ready_to_publish'"/>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                  <template slot="singleLabel" slot-scope="props">
                    <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'published'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'edit_mode'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle" class="risk-9" v-if="props.option.value == 'ready_to_publish'"/>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>
              </b-form-group>
              <br>
              <b-form-group>
                <b-form-checkbox v-model="form.notification" name="check-button" switch class="icon-success">
                  {{ $t('maintenance.policies.documents.notification_label') }}
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>

        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateDocumentModal"
                    qid="create-rr-cancel-button"
          >
            {{ $t('activities.measures.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-rr-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('activities.measures.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Edit document  -->
    <b-modal ref="edit-document" hide-footer @hide="hideEditDocumentModal" size="lg">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('maintenance.third_parties.documents.edit_modal_title')}}
        </h4>
      </div>
      <b-alert v-if="edit_error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ edit_error }}
      </b-alert>
      <b-form @submit="formEditSubmit" qid="create-ac-form">
        <div class="form-container">
          <div class="row">
            <div class="col-sm-12">
              <b-form-group>
                <label qid="create-tp-name-label">
                  {{ $t('maintenance.third_parties.create.name_label') }}
                </label>
                <span class="text-red">*</span>
                <b-form-input
                  qid="create-tp-form-name"
                  type="text"
                  v-model="form.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.third_parties.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>

              <b-form-group :class="{'multiselect--show-input': categoryInput.length}">
                <label qid="create-do-type-label">
                  {{ $t('maintenance.third_parties.documents.category') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="form.category"
                    :options="categoryItems"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('maintenance.data_objects.create.category_placeholder')"
                    label="category"
                    :preserveSearch="true"
                    @search-change="handleCategoryInput"
                    qid="create-do-form-category"
                >
                  <template slot="noResult" slot-scope="props">
                    {{ $t('maintenance.data_objects.create.category_no_results') }}
                  </template>
                </multiselect>
              </b-form-group>


              <b-form-group class="mt-3">
                <label qid="create-tp-attachments-label">
                  {{ $t('maintenance.policies.create.attachments_and_links') }}
                </label>
                <span class="text-red">*</span>
                <br>

                <div class="form-control auto-height mt-1">
                  <div class="text-muted" v-if="selectedTableItem.media && !selectedTableItem.media.length && selectedTableItem.links && !selectedTableItem.links.length">
                    {{ $t('maintenance.policies.documents.no_attachments') }}
                  </div>
                  <div v-for="(file, index) in selectedTableItem.media">
                    <div class="row">
                      <div class="col-sm-1">
                        <font-awesome-icon
                          icon="star"
                          :class="{'color-yellow': isMasterFile(file, selectedTableItem), 'text-light': !isMasterFile(file, selectedTableItem)}"
                          class="cursor-pointer"
                          @click="setEditMaster(file)"
                          v-if="file.mime_type == 'application/pdf'"
                        />
                      </div>
                      <div class="col-sm-11">
                        <span class="float-right text-muted cursor-pointer"
                              @click="showFileModal(file, index)"
                              qid="remove-media-item"
                              v-if="!isMasterFile(file, selectedTableItem)"
                        >
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                        <span class="mr-3 float-right text-muted cursor-pointer"
                              @click="downloadMedia(file)"
                              qid="download-media"
                        >
                          <font-awesome-icon icon="cloud-download-alt" />
                        </span>
                        <a @click="downloadMedia(file)" qid="create-tp-media-item">
                          {{ file.file_name }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="selectedTableItem.links">
                    <div v-for="(link, index) in selectedTableItem.links" >
                      <div class="row">
                        <div class="col-sm-1">
                          <font-awesome-icon
                            icon="star"
                            :class="{'color-yellow': isMasterLink(link, selectedTableItem), 'text-light': !isMasterLink(link, selectedTableItem)}"
                            class="cursor-pointer"
                            @click="setEditLinkMaster(link)"
                          />
                        </div>
                        <div class="col-sm-11">
                          <span class="float-right text-muted cursor-pointer"
                                @click="showLinkModal(link, index)"
                                qid="view-tp-remove-link"
                                v-if="!isMasterLink(link, selectedTableItem)"
                          >
                            <font-awesome-icon icon="trash-alt" />
                          </span>
                          <a :href="link.url" target="_blank" qid="create-tp-link-item">
                            {{ link.name ? link.name : link.url }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-1">
                  <span class="text-light">
                    {{ $t('maintenance.policies.create.attachments_tip') }}
                  </span>
                </div>
                <br>
                <div class="mt-1">
                  <span class="btn btn-link cursor-pointer"
                        @click="showEditInput = true"
                        qid="add-another-link"
                  >
                    <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
                  </span>
                  <label class="ml-3 mb-0 btn btn-link cursor-pointer" qid="create-tp-attachments-button">
                    <input type="file"
                           name="fileupload"
                           value="fileupload"
                           multiple
                           id="file"
                           @change="onEditFileChange"
                           @click="resetFile"
                    >
                    <span>
                      <font-awesome-icon icon="plus"/>
                      {{ $t('system.add_attachment') }}
                    </span>
                  </label>
                </div>
              </b-form-group>

              <b-form-group>
                <div v-if="showEditInput">
                  <label class="mt-2">{{ $t('system.link') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputEditLink"
                    :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                    qid="create-p-links"
                  ></b-form-input>
                  <label class="mt-2">{{ $t('table.name') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputEditLinkName"
                    :placeholder="inputEditLink ? inputEditLink : $t('table.name')"
                    qid="create-p-links"
                  ></b-form-input>
                  <div class="text-right mt-2">
                    <span class="btn btn-success cursor-pointer mr-0"
                          id="inputGroup"
                          @click="handleEditLink"
                          qid="handle-link-save"
                    >
                      {{ $t('system.save') }}
                    </span>
                  </div>
                </div>
              </b-form-group>


              <b-form-group>
                <label qid="create-do-contact-label">
                  {{ $t('maintenance.policies.documents.status_label') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="form.status"
                    :options="statusItems"
                    :placeholder="$t('maintenance.policies.documents.status_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-do-form-classification"
                >
                  <template slot="option" slot-scope="props">
                    <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'published'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'edit_mode'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle" class="risk-9" v-if="props.option.value == 'ready_to_publish'"/>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                  <template slot="singleLabel" slot-scope="props">
                    <font-awesome-icon icon="check-circle" class="icon-success" v-if="props.option.value == 'published'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle" class="icon-info" v-if="props.option.value == 'edit_mode'" style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle" class="risk-9" v-if="props.option.value == 'ready_to_publish'"/>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>
              </b-form-group>
              <br>
              <b-form-group>
                <b-form-checkbox v-model="form.notification" name="check-button" switch class="icon-success">
                  {{ $t('maintenance.policies.documents.notification_label') }}
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>

        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditDocumentModal"
                    qid="create-rr-cancel-button"
          >
            {{ $t('activities.measures.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-rr-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('system.save') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- View document modal -->
    <b-modal ref="view-document" hide-footer @hide="hideViewDocumentModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('maintenance.third_parties.documents.view_modal_title')}}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>

      <div v-if="selectedViewItem">
        <label qid="create-tp-name-label" class="mt-3">
          {{ $t('maintenance.third_parties.create.name_label') }}
        </label>
        <br>
        <div class="section-container">
          <span qid="network-name">
            {{ selectedViewItem.name }}
          </span>
        </div>
        <br>

        <label qid="create-do-type-label" class="mt-3">
          {{ $t('maintenance.data_objects.create.category_label') }}
        </label>
        <br>
        <div class="section-container">
          <span qid="network-name" class="text-normal">
            {{ selectedViewItem.category }}
          </span>
        </div>
        <br>
      </div>

      <label class="mt-3">
        {{ $t('maintenance.policies.create.attachments_and_links') }}
      </label>

      <div class="section-container">

        <div v-for="(file, index) in selectedViewItem.media">
          <div class="row">
            <div class="col-sm-1">
              <font-awesome-icon
                v-if="isMasterFile(file, selectedViewItem)"
                icon="star"
                class="color-yellow cursor-pointer"
              />
            </div>
            <div class="col-sm-11">
              <span class="mr-3 float-right text-muted cursor-pointer"
                    @click="downloadMedia(file)"
                    qid="download-media"
              >
                <font-awesome-icon icon="cloud-download-alt" />
              </span>
              <a @click="downloadMedia(file)" qid="create-tp-media-item">
                {{ file.file_name }}
              </a>
            </div>
          </div>
        </div>

        <div v-for="(link, index) in selectedViewItem.links">
          <div class="row">
            <div class="col-sm-1">
              <font-awesome-icon
                v-if="isMasterLink(link, selectedViewItem)"
                icon="star"
                class="color-yellow cursor-pointer"
              />
            </div>
            <div class="col-sm-11">
              <a :href="link.url" target="_blank" qid="create-tp-link-item">
                {{ link.name ? link.name : link.url }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="text-right mt-2">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideViewDocumentModal"
                  qid="create-rr-cancel-button"
        >
          {{ $t('system.close') }}
        </b-button>
      </div>

    </b-modal>


    <!-- View document list modal -->
    <b-modal ref="view-document-list" hide-footer @hide="hideViewDocumentListModal" size="xl">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('maintenance.third_parties.documents.view_modal_title')}}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>

      <div class="text-right">
        <button class="btn btn-secondary"
                @click="showCreateDocumentModal(selectedItem)"
                qid="retention-rule-create-button"
                v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], policy) && (!getClient.parent || (getClient.parent && policy.partition)) && selectedItem && (!selectedItem.latest_version || (selectedItem.latest_version && selectedItem.latest_version.status == 'published'))"
        >
          <font-awesome-icon icon="plus"/> {{ $t('maintenance.third_parties.documents.add_new_version') }}
        </button>
      </div>

      <table class="table table-responsive-md table-list-secondary">
        <thead>
        <tr>
          <th scope="col" width="300">
            {{ $t('activities.measures.table.name') }}
          </th>
          <th scope="col" width="100">
            {{ $t('maintenance.policies.documents.version') }}
          </th>
          <th scope="col" width="180">
            {{ $t('maintenance.third_parties.documents.category') }}
          </th>
          <th scope="col" width="120">
            {{ $t('maintenance.third_parties.documents.start_date') }}
          </th>
          <th scope="col" class="text-center" width="180">
            {{ $t('maintenance.policies.documents.published') }}
          </th>
          <th width="330"></th>
        </tr>
        </thead>
        <tbody>
          <tr v-if="documentSingleTableItems && documentSingleTableItems.length">
            <td>
              <button
                  style="word-break:break-word;"
                  @click="openViewDocumentModal(documentSingleTableItems[0])"
                  class="btn btn-link btn-sm text-left"
              >
                {{ documentSingleTableItems[0].name }}
              </button>
            </td>
            <td>
              <span class="text-normal">
                {{ documentSingleTableItems[0].version }}
              </span>
            </td>
            <td>
              <span v-if="documentSingleTableItems[0] && documentSingleTableItems[0].category" class="text-normal">
                <font-awesome-icon icon="shapes"/>
                {{ documentSingleTableItems[0].category }}
              </span>
            </td>
            <td>
              <span v-if="documentSingleTableItems[0].start_date" class="text-normal">
                {{ documentSingleTableItems[0].start_date | formatDate }}
              </span>
            </td>
            <td class="text-center">
              <span v-if="documentSingleTableItems[0] && documentSingleTableItems[0].status == 'published'" class="text-normal">
                <font-awesome-icon icon="check-circle" class="icon-success" style="background:white;border-radius:50%;"/>
              </span>
            </td>
            <td class="text-right">
              <!-- <span class="btn btn-edit"
                    qid="edit-p-modal"
                    @click="showEditDocumentsModal(documentSingleTableItems[0])"
                    v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], documentSingleTableItems[0]) && (!getClient.parent || (getClient.parent && documentSingleTableItems[0].partition))"
              >
                <font-awesome-icon icon="pen"/>
              </span> -->
              <button
                  @click="openViewDocumentModal(documentSingleTableItems[0])"
                  class="btn btn-view"
              >
                <font-awesome-icon icon="eye"/>
              </button>
            </td>
          </tr>
          <tr v-if="!documentSingleTableItems.length" qid="no-results-row-rr" class="text-center">
            <td colspan="10">
              <h5 class="mt-3">
                {{ $t('system.no_results') }}
              </h5>
            </td>
          </tr>
        </tbody>
      </table>

      <br>
      <div class="text-center mb-2 mt-2" v-if="selectedItem && selectedItem.latest_version && selectedItem.latest_version.status != 'published'">
        <span>
          <span class="">
            {{ $t('maintenance.policies.documents.pending_documents') }}
          </span>
        </span>
      </div>

      <table class="table table-responsive-md table-list-secondary unpublished" v-if="selectedItem && selectedItem.latest_version && selectedItem.latest_version.status != 'published'">
        <tbody>
          <tr>
            <td width="300">
              <button
                  style="word-break:break-word;"
                  @click="openViewDocumentModal(selectedItem.latest_version)"
                  class="btn btn-link btn-sm text-left"
              >
                {{ selectedItem.latest_version.name }}
              </button>
            </td>
            <td width="100">
              <span class="text-normal">
                {{ selectedItem.latest_version.version }}
              </span>
            </td>
            <td width="180">
              <span v-if="selectedItem.latest_version && selectedItem.latest_version.category" class="text-normal">
                <font-awesome-icon icon="shapes"/>
                {{ selectedItem.latest_version.category }}
              </span>
            </td>
            <td width="120">
              <span v-if="selectedItem.latest_version.start_date && selectedItem.latest_version.status == 'published'" class="text-normal">
                {{ selectedItem.latest_version.start_date | formatDate }}
              </span>
              <span v-else class="text-normal">
                {{ $t('system.n_a') }}
              </span>
            </td>
            <td width="180" class="text-center">
              <span v-if="selectedItem.latest_version.status && selectedItem.latest_version.status == 'published'" class="text-normal">
                  <font-awesome-icon icon="check-circle" class="icon-success" style="background:white;border-radius:50%;"/>
                  {{ $t('system.' + $options.filters.slugify(selectedItem.latest_version.status)) }}
              </span>
              <span v-if="selectedItem.latest_version.status && selectedItem.latest_version.status == 'edit_mode'" class="text-normal">
                  <font-awesome-icon icon="info-circle" class="icon-info" style="background:white;border-radius:50%;"/>
                  {{ $t('system.' + $options.filters.slugify(selectedItem.latest_version.status)) }}
              </span>
              <span v-if="selectedItem.latest_version.status && selectedItem.latest_version.status == 'ready_to_publish'" class="text-normal">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-9"/>
                  {{ $t('system.' + $options.filters.slugify(selectedItem.latest_version.status)) }}
              </span>
            </td>
            <td class="text-right" width="330">
              <span class="btn btn-success"
                    qid="edit-p-modal"
                    @click="showPublishDocumentModal()"
                    v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], policy) && (!getClient.parent || (getClient.parent && policy.partition)) && selectedItem.latest_version.status == 'ready_to_publish' && isOwner(policy)"
              >
                {{ $t('maintenance.policies.documents.publish_label') }}
              </span>
              <span class="btn btn-secondary"
                    qid="edit-p-modal"
                    @click="showConfirmEditModeModal(selectedItem.latest_version)"
                    v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], policy) && (!getClient.parent || (getClient.parent && policy.partition)) && selectedItem.latest_version.status == 'ready_to_publish' && isOwner(policy)"
              >
                {{ $t('system.edit_mode') }}
              </span>
              <span class="btn btn-edit"
                    qid="edit-p-modal"
                    @click="showEditDocumentsModal(selectedItem.latest_version)"
                    v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], policy) && (!getClient.parent || (getClient.parent && policy.partition)) && selectedItem.latest_version.status == 'edit_mode'"
              >
                <font-awesome-icon icon="pen"/>
              </span>
              <button
                  @click="openViewDocumentModal(selectedItem.latest_version)"
                  class="btn btn-view"
              >
                <font-awesome-icon icon="eye"/>
              </button>
              <button class="btn btn-delete"
                      qid="delete-document-modal"
                      @click="showDocumentConfirmDeleteModal(selectedItem.latest_version, 'pending')"
                      v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], policy) && (!getClient.parent || (getClient.parent && policy.partition))"
              >
                <font-awesome-icon icon="trash-alt" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>


      <br>
      <div class="text-center mb-4 mt-2">
        <span class="cursor-pointer"
              @click="showHistoricDocuments = !showHistoricDocuments"
              qid="network-validation-expand"
        >
          <span class="mr-2">
            {{ $t('maintenance.third_parties.documents.historic_documents') }}
          </span>
          <font-awesome-icon icon="chevron-down" v-if="!showHistoricDocuments"/>
          <font-awesome-icon icon="chevron-up" v-if="showHistoricDocuments"/>
        </span>
      </div>

      <div v-show="showHistoricDocuments">
        <table class="table table-responsive-md table-list-secondary">
          <thead>
          <tr>
            <th scope="col">
              {{ $t('activities.measures.table.name') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.policies.documents.version') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.category') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.start_date') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.documents.end_date') }}
            </th>
            <th width="180"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(object, index) in documentSingleTableItems"
                v-if="index > 0"
            >
              <td>
                <button
                    @click="openViewDocumentModal(object)"
                    class="btn btn-link btn-sm text-left"
                    style="word-break:break-word;"
                >
                  {{ object.name }}
                </button>
              </td>
              <td>
                <span class="text-normal">
                  {{ object.version }}
                </span>
              </td>
              <td>
                <span v-if="object && object.category" class="text-normal">
                  <font-awesome-icon icon="shapes"/>
                  {{ object.category }}
                </span>
              </td>
              <td>
                <span v-if="object.start_date" class="text-normal">
                  {{ object.start_date | formatDate }}
                </span>
              </td>
              <td>
                <span v-if="object.end_date" class="text-normal">
                  {{ object.end_date | formatDate }}
                </span>
              </td>
              <td class="text-right">
                <!-- <span class="btn btn-edit"
                      qid="edit-p-modal"
                      @click="showEditDocumentsModal(object)"
                      v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], object) && (!getClient.parent || (getClient.parent && object.partition))"
                >
                  <font-awesome-icon icon="pen"/>
                </span> -->
                <button
                        @click="openViewDocumentModal(object)"
                        class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </button>
                <button class="btn btn-delete"
                        qid="delete-document-modal"
                        @click="showDocumentConfirmDeleteModal(object)"
                        v-if="isGranted([permissions.POLICY_EDIT, permissions.POLICY_EDIT_OWN], policy) && (!getClient.parent || (getClient.parent && policy.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </button>
              </td>
            </tr>
            <tr v-if="!measureLoading && documentSingleTableItems.length < 2" qid="no-results-row-rr" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideViewDocumentListModal"
                  qid="create-rr-cancel-button"
        >
          {{ $t('system.close') }}
        </b-button>

      </div>
    </b-modal>


    <!-- Delete attachment modal -->
    <b-modal ref="delete-attachment-modal" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-s-title">
          {{ $t('attachments.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        <span>
          {{ $t('attachments.delete.are_you_sure_file') }}
        </span>
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideFileModal"
                  qid="delete-attachment-cancel-button"
        >
          {{ $t('attachments.delete.cancel') }}
        </b-button>
        <b-button @click="removeMediaItem(selectedFileObject, selectedFileIndex)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-attachment-submit-button"
        >
          {{ $t('attachments.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Delete link modal -->
    <b-modal ref="delete-link-modal" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-s-title">
          {{ $t('attachments.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        <span>
          {{ $t('attachments.delete.are_you_sure_link') }}
        </span>
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideLinkModal"
                  qid="delete-link-cancel-button"
        >
          {{ $t('attachments.delete.cancel') }}
        </b-button>
        <b-button @click="removeLink(selectedLinkObject, selectedLinkIndex)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-link-submit-button"
        >
          {{ $t('attachments.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Confirm edit mode modal template -->
    <b-modal ref="confirm-edit-mode" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-s-title">
          {{ $t('maintenance.policies.documents.edit_mode_modal_title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.policies.documents.edit_mode_notice') }}<br />{{ itemToChangeStatus.title }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmEditModeModal"
                  qid="delete-s-cancel-button"
        >
          {{ $t('system.cancel') }}
        </b-button>
        <b-button @click="setEditModeDocument(itemToChangeStatus)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-s-submit-button"
        >
          {{ $t('maintenance.policies.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Publish document modal template -->
    <b-modal ref="publish-document" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-s-title">
          {{ $t('maintenance.policies.documents.changelog_modal_title') }}
        </h4>
      </div>
      <b-alert v-if="publish_error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ publish_error }}
      </b-alert>
      <div class="form-container">
        <b-form-group>
          <label qid="create-p-description-label">
            {{ $t('maintenance.policies.create.description_label') }}
          </label>
          <span class="text-red">*</span>
          <b-form-textarea
            qid="create-p-form-description"
            v-model="change_log"
            rows="5"
            max-rows="7"
            :placeholder="$t('maintenance.policies.create.description_placeholder')"
          ></b-form-textarea>
        </b-form-group>
      </div>

      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hidePublishDocumentModal"
                  qid="delete-s-cancel-button"
        >
          {{ $t('system.cancel') }}
        </b-button>
        <b-button @click="publishDocument(selectedItem.latest_version)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-s-submit-button"
        >
          {{ $t('maintenance.policies.documents.publish_label') }}
        </b-button>
      </div>
    </b-modal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import roleCheck from "@/util/ACL/roleCheck"
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import MeasureCreateForm from '@/views/Measures/MeasureCreateForm.vue'
  import Datepicker from 'vuejs-datepicker';
  import GuideButton from '@/components/guide/GuideButton.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';


  export default {
    name: 'DocumentsTable',
    data: function() {
      return {
        form: {
          name: '',
          category: [],
          status: [],
          links: [],
          notification: false
        },
        change_log: '',
        error: '',
        add_error: '',
        edit_error: '',
        publish_error: '',
        loadingItems: false,
        selectedDocument: [],
        selectedTableItem: [],
        viewRRModal: false,
        editRRModal: false,
        selectedDocumentSort: '',
        selectedDocumentDirection: '',
        acValidationShow: false,
        documentTableItems: [],
        documentSingleTableItems: [],
        measureLoading: true,
        measureItems: [],
        updateValidationList: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: undefined,
        disabledValidationOptions: [],
        showRRDescription: false,
        buttonDisabled: false,
        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,
        selectedSort: '',
        selectedDirection: '',
        filterOpened: false,
        keywordValue: '',
        selectedItem: {},
        selectedParentDocument: {},
        viewMeasureModal: false,
        myGuides: [],
        selectedAnswer: [],
        selectedDate: '',
        selectedNumber: '',
        inputLinkName: '',
        inputLink: '',
        inputEditLinkName: '',
        inputEditLink: '',
        allAnswers: [],
        selectedFiles: [],
        categoryItems: [],
        categoryInput: '',
        statusItems: [
          { name: this.$t('system.ready_to_publish'), value: 'ready_to_publish' },
          { name: this.$t('system.edit_mode'), value: 'edit_mode' }
        ],
        checklistOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0},
        ],
        showHistoricDocuments: false,
        hasEndDate: 1,
        selectedViewItem: {},
        showInput: false,
        showEditInput: false,
        showSingleLinkLabel: true,
        selectedFileObject: {},
        selectedFileIndex: '',
        selectedLinkObject: {},
        selectedLinkIndex: '',
        itemToChangeStatus: {},
        selectedCategory: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      tasks: {
        type: Array
      },
      showOnTask: {},
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      Datepicker,
      MeasureCreateForm,
      GuideButton,
      UpdateSingleTaskModal
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getFiles() {
        return this.selectedFiles
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadCategories();
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_documents')
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.policy.id && this.$store.state.updatedObject.who_am_i == this.policy.who_am_i) {
              this.policy = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      object: function (value) {
        this.policy = value
        if (this.policy && this.policy.slug) {
          this.loadDocuments();
          this.loadTasks('update_documents')
        }
      }
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadDocuments()
      }, 400),
      checkIfAdmin() {
        if (roleCheck('Client admin') || roleCheck('Partition admin')) {
          return true
        } else {
          return false
        }
      },
      reloadContent() {
        this.loadContent()
        this.loadTasks('update_documents');
      },
      isOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.users, function(user) {
          return user.id == self.getUser.id && user.owner
        });

        if (existingUser) {
          allow = true
        } else {
          if (roleCheck('Client admin') || roleCheck('Partition admin') || this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      openDocument(object) {
        if (object.master) {

          if (object.master.who_am_i == 'App\\Maintenance\\Links\\Models\\Link') {
            window.open(object.master.url);
          }

          if (object.master.who_am_i == 'App\\Maintenance\\Document\\Models\\Document') {
            piincHttp.get('documents/' + object.master.id + '/download', {responseType: 'blob'}).then(function(response) {
              const blobURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
              window.open(blobURL);
            }, function() {});
          }
        }
      },
      isMasterLink(object, tableItem) {
        let isMaster = false
        if (tableItem.master && tableItem.master.who_am_i == 'App\\Maintenance\\Links\\Models\\Link' && tableItem.master.id == object.id) {
          isMaster = true
        }
        return isMaster
      },
      isMasterFile(object, tableItem) {
        let isMaster = false
        if (tableItem.master && tableItem.master.who_am_i == 'App\\Maintenance\\Document\\Models\\Document' && tableItem.master.id == object.id) {
          isMaster = true
        }
        return isMaster
      },
      showFileModal(object, index) {
        let self = this
        this.selectedFileObject = object;
        this.selectedFileIndex = index;
        this.$refs['delete-attachment-modal'].show()
      },
      hideFileModal() {
        this.$refs['delete-attachment-modal'].hide()
      },
      showLinkModal(object, index) {
        let self = this
        this.selectedLinkObject = object;
        this.selectedLinkIndex = index;
        this.$refs['delete-link-modal'].show()
      },
      hideLinkModal() {
        this.$refs['delete-link-modal'].hide()
      },
      removeLink(object, index) {
        let self = this;
        piincHttp.delete('links/'+object.id).then(function() {
          self.selectedTableItem.links.splice(index, 1);
          self.hideLinkModal();
          self.$toastr('success', self.$t('processes.legal_basis.link_delete_success'))
        }, function() {})
      },
      removeMediaItem(object, index) {
        let self = this;
        piincHttp.delete('documents/'+ object.id).then(function() {
          self.selectedTableItem.media.splice(index, 1);
          self.hideFileModal();
          self.$toastr('success', self.$t('processes.legal_basis.media_delete_success'))
        }, function() {})
      },
      setMaster(index) {
        let oldMaster = false;
        let selectedItem = this.selectedFiles[index]

        if (selectedItem.master) {
          oldMaster = true
        }

        _.forEach(this.selectedFiles, function (item) {
          item.master = false;
        })
        _.forEach(this.form.links, function (item) {
          item.master = false;
        })

        if (oldMaster) {
          selectedItem.master = false;
        } else {
          selectedItem.master = true;
        }

        this.$set(this.selectedFiles, index, selectedItem)
      },
      setLinkMaster(index) {
        let selectedLinkItem = this.form.links[index]
        let oldMaster = false;

        if (selectedLinkItem.master) {
          oldMaster = true
        }

        _.forEach(this.form.links, function (item) {
          item.master = false;
        })
        _.forEach(this.selectedFiles, function (item) {
          item.master = false;
        })

        if (oldMaster) {
          selectedLinkItem.master = false;
        } else {
          selectedLinkItem.master = true;
        }

        this.$set(this.form.links, index, selectedLinkItem)
      },
      setEditMaster(item) {
        let self = this;
        let master = ''

        if (this.isMasterFile(item, this.selectedTableItem)) {
          master = {

          }
        } else {
          master = {
              master: {type: 'document', id: item.id}
          }
        }

        piincHttp.put('/policies/' + this.policy.slug + '/documents/' + this.selectedTableItem.id, master).then(function(response) {
          self.selectedTableItem = response.data
          self.loadDocuments(self.currentPage);
          self.loadChildDocuments();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      setEditLinkMaster(item) {
        let self = this;
        let master = ''

        if (this.isMasterLink(item, this.selectedTableItem)) {
          master = {

          }
        } else {
          master = {
              master: {type: 'link', id: item.id}
          }
        }

        piincHttp.put('/policies/' + this.policy.slug + '/documents/' + this.selectedTableItem.id, master).then(function(response) {
          self.selectedTableItem = response.data
          self.loadDocuments(self.currentPage);
          self.loadChildDocuments();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      openViewDocumentListModal(object) {
        this.selectedItem = object
        this.loadChildDocuments()
        this.$refs['view-document-list'].show()
      },
      hideViewDocumentListModal () {
        this.showHistoricDocuments = false;
        this.selectedItem = []
        this.$refs['view-document-list'].hide()
      },
      openViewDocumentModal(object) {
        this.selectedViewItem = object
        this.$refs['view-document'].show()
      },
      hideViewDocumentModal () {
        this.selectedViewItem = []
        this.$refs['view-document'].hide()
      },
      handleCategoryInput(input) {
        this.categoryInput = input;
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadDocuments();
      },
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      loadTasks(code) {
        let self = this;
        piincHttp.get('projects/me/tasks', { params:
          {
            per_page: 1,
            status: 'pending',
            model_type: this.policy.who_am_i,
            model_id: this.policy.id,
            code: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.myTasks = []
          if (response.data.items.length) {
            self.myTasks.push(response.data.items[0])
          }
        }, function() {});
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Policy' && object.enabled
        });
        return existingGuide
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Policy',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      onFileChange(file) {
        let files = file.target.files;
        let self = this;
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.length; i++) {
          this.selectedFiles.push(files[i])
        }
      },
      onEditFileChange(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.selectedTableItem.who_am_i);
        formData.append("model_id", this.selectedTableItem.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('processes.legal_basis.media_add_success'))
            self.error = ''
            self.selectedTableItem.media = response.data.media
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      handleEditLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputEditLink.startsWith('http')) {
          this.inputEditLink = 'http://' + this.inputEditLink
        }

        formData.append("url", this.inputEditLink);
        formData.append("name", this.inputEditLinkName);
        formData.append("model_type", this.selectedTableItem.who_am_i);
        formData.append("model_id", this.selectedTableItem.id);

        piincHttp.post('links', formData).then(function(response) {
          self.$toastr('success', self.$t('processes.legal_basis.link_add_success'))
          self.selectedTableItem.links = response.data.links
          self.inputEditLink = ''
          self.inputEditLinkName = ''
          self.showEditInput = false
        }, function() {})
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.form.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
          this.showInput = false;
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.form.links.splice(index, 1);
      },
      showCreateDocumentModal(parent) {
        let self = this;
        this.loadCategories();
        this.form.name = ''
        this.form.notification = false
        this.form.status = []
        this.form.category = []
        this.selectedCategory = []
        this.categoryInput = ''
        this.form.links = []
        this.selectedDocument = []
        this.selectedFiles = []
        this.selectedParentDocument = parent
        if (this.selectedParentDocument && this.selectedParentDocument.id) {

          // Prepopulate name from parent
          this.form.name = this.selectedParentDocument.latest_version.name

          // If there's category, prepopulate also
          if (this.selectedParentDocument.latest_version.category) {
            this.selectedCategory = []
            _.forEach(this.categoryItems, function(item) {
              if (item.category == self.selectedParentDocument.latest_version.category) {
                self.selectedCategory = item;
              }
            });
          }
        } else {
          this.form.name = ''
        }
        this.$refs['add-document'].show()
      },
      hideCreateDocumentModal() {
        this.error = ''
        this.add_error = ''
        this.selectedTableItem = []
        this.loadContent()
        this.selectedParentDocument = []
        this.$refs['add-document'].hide()
      },
      showEditDocumentsModal(object) {
        let self = this;
        this.form.name = ''
        this.form.notification = false
        this.form.status = []
        this.form.category = []
        this.categoryInput = ''

        this.selectedTableItem = object

        if (object.status) {
          this.form.status = _.find(this.statusItems, function(item) {
            return item.value === object.status;
          });
        }

        if (object.category) {
          this.form.category = []
          this.form.category = _.find(this.categoryItems, function(item) {
            return item.category === object.category;
          });
        }

        this.form.name = object.name;
        this.form.notification = object.notification

        this.$refs['edit-document'].show()
      },
      hideEditDocumentModal() {
        this.edit_error = ''
        this.selectedDocument = []
        this.loadContent()
        this.$refs['edit-document'].hide()
      },
      showDocumentConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-document'].show()
      },
      hideDocumentConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent()
        this.$refs['delete-document'].hide()
      },
      confirmDeleteDocument(object) {
        let self = this;
        piincHttp.delete('policies/' + this.policy.slug + '/documents/' + object.id).then(function() {
          if (self.selectedItem && self.selectedItem.latest_version && !self.documentSingleTableItems.length) {
            self.hideViewDocumentListModal()
          }
          self.hideDocumentConfirmDeleteModal();
          self.loadChildDocuments();
          self.loadDocuments();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.third_parties.documents.delete.success'))
        }, function() {});
      },
      formSubmit(evt) {
        let formData = new FormData();
        let files = document.querySelector('#file');
        let sizeError = false;
        var moment = require('moment');

        this.handleLink();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        let fileIndex = _.findIndex(this.selectedFiles, function(file) { return file.master; });
        let linkIndex = _.findIndex(this.form.links, function(link) { return link.master; });

        if (fileIndex != -1) {
          formData.append("master", JSON.stringify({type: 'document', index: fileIndex}));
        }

        if (linkIndex != -1) {
          formData.append("master", JSON.stringify({type: 'link', index: linkIndex}));
        }

        // Append list of attachments to FormData
        for (var i = 0; i < this.selectedFiles.length; i++) {
          // Equal to 10 MB
          if (this.selectedFiles[i].size > 10485760) {
            sizeError = true;
          }
          formData.append("files[]", this.selectedFiles[i]);
        }

        // Append list of links to FormData
        for (var i = 0; i < this.form.links.length; i++) {
          formData.append("links[]", JSON.stringify(this.form.links[i]));
        }

        // Additional check - if category is selected, append it to form data
        if (this.categoryInput && this.categoryInput.length) {
          formData.append("category", this.categoryInput);
        } else {
          if (this.selectedCategory && this.selectedCategory.category) {
            formData.append("category", this.selectedCategory.category);
          } else {
            formData.append("category", '');
          }
        }

        if (this.form.status && this.form.status.value) {
          formData.append("status", this.form.status.value);
        }

        if (this.selectedParentDocument && this.selectedParentDocument.id) {
          formData.append("policy_document_id", this.selectedParentDocument.id);
        }

        formData.append("name", this.form.name);
        formData.append("notification", this.form.notification);

        if (sizeError) {
          this.add_error = this.$t('system.file_size')
        } else {
          if (
              ((this.form.status && this.form.status.value && this.form.status.value != 'ready_to_publish') || (this.form.status && this.form.status.value && this.form.status.value == 'ready_to_publish' && (fileIndex != -1 || linkIndex != -1))) &&
              ((this.selectedCategory && this.selectedCategory.category) || (this.categoryInput && this.categoryInput.length)) &&
              ((this.selectedFiles && this.selectedFiles.length) || (this.form.links && this.form.links.length))
          ) {
            this.buttonDisabled = true;
            piincHttp.post('/policies/' + this.policy.slug + '/documents', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.loadChildDocuments()
              self.loadCategories();
              self.loadDocuments(self.currentPage);
              self.$toastr('success', self.$t('maintenance.third_parties.documents.update_success'))
              self.hideCreateDocumentModal();
              self.$emit('updated');
              self.buttonDisabled = false;
              self.form.category = [];
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.add_error = error.data.message;
                if (error.data.errors.measure_id) {
                  self.add_error += ' ' + error.data.errors.measure_id[0]
                }
              }
            })
          } else {
            this.add_error = ''

            if ((!this.selectedCategory || (this.selectedCategory && !this.selectedCategory.category)) && !this.categoryInput.length) {
              this.add_error +=  ' ' +  this.$t('maintenance.third_parties.create.category_error')
            }
            if ((this.selectedFiles && !this.selectedFiles.length) && (this.form.links && !this.form.links.length)) {
              this.add_error += ' ' + this.$t('tasks.modal.attachments_error_message')
            }
            if (!this.form.status || (this.form.status && !this.form.status.value)) {
              this.add_error +=  ' ' + this.$t('maintenance.policies.documents.status_error')
            }
            if (this.form.status && this.form.status.value && this.form.status.value == 'ready_to_publish' && fileIndex == -1 && fileIndex == -1) {
              this.add_error +=  ' ' + this.$t('maintenance.policies.documents.master_error')
            }
            this.buttonDisabled = false;
          }

        }

      },
      formEditSubmit(evt) {

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (
            ((this.form.status && this.form.status.value && this.form.status.value != 'ready_to_publish') || (this.form.status && this.form.status.value && this.form.status.value == 'ready_to_publish' && this.selectedTableItem.master && this.selectedTableItem.master.id)) &&
            ((this.form.category && this.form.category.category) || (this.categoryInput && this.categoryInput.length)) &&
            ((this.selectedTableItem.media && this.selectedTableItem.media.length) || (this.selectedTableItem.links && this.selectedTableItem.links.length))
        ) {
          this.buttonDisabled = true;

          this.form.status = this.form.status ? this.form.status.value : ''

          if (this.categoryInput && this.categoryInput.length) {
            this.form.category = this.categoryInput
          } else {
            if (this.form.category && this.form.category.category) {
              this.form.category = this.form.category.category
            } else {
              this.form.category = '';
            }
          }

          this.form.links = undefined;
          this.form.notification = this.form.notification

          if (this.selectedTableItem.master && this.selectedTableItem.master.id) {
            if (this.selectedTableItem.master.who_am_i == 'App\\Maintenance\\Links\\Models\\Link') {
              this.form.master = {type: 'link', id: this.selectedTableItem.master.id}
            }
            if (this.selectedTableItem.master.who_am_i == 'App\\Maintenance\\Document\\Models\\Document') {
              this.form.master = {type: 'document', id: this.selectedTableItem.master.id}
            }
          }

          piincHttp.put('/policies/' + this.policy.slug + '/documents/' + this.selectedTableItem.id, this.form).then(function(response) {
            self.hideEditDocumentModal();
            self.loadDocuments(self.currentPage);
            self.loadChildDocuments();
            self.buttonDisabled = false;
            self.$toastr('success', self.$t('maintenance.third_parties.documents.update_success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.edit_error = ''

          if ((!this.form.category || (this.form.category && !this.form.category.category)) && !this.categoryInput.length) {
            this.edit_error +=  ' ' +  this.$t('maintenance.third_parties.create.category_error')
          }
          if ((this.selectedTableItem.media && !this.selectedTableItem.media.length) && (this.selectedTableItem.links && !this.selectedTableItem.links.length)) {
            this.edit_error += ' ' + this.$t('tasks.modal.attachments_error_message')
          }
          if (!this.form.status || (this.form.status && !this.form.status.value)) {
            this.edit_error +=  ' ' + this.$t('maintenance.policies.documents.status_error')
          }
          if (this.form.status && this.form.status.value && this.form.status.value == 'ready_to_publish' && !this.selectedTableItem.master) {
            this.edit_error +=  ' ' + this.$t('maintenance.policies.documents.master_error')
          }
          this.buttonDisabled = false;
        }

      },
      publishDocument(object) {
        let self = this;
        let masterObject = {};

        if (this.change_log && this.change_log.length) {

          if (this.selectedItem.latest_version.master && this.selectedItem.latest_version.master.id) {
            if (this.selectedItem.latest_version.master.who_am_i == 'App\\Maintenance\\Links\\Models\\Link') {
              masterObject = {type: 'link', id: this.selectedItem.latest_version.master.id}
            }
            if (this.selectedItem.latest_version.master.who_am_i == 'App\\Maintenance\\Document\\Models\\Document') {
              masterObject = {type: 'document', id: this.selectedItem.latest_version.master.id}
            }
          }

          piincHttp.put('/policies/' + this.policy.slug + '/documents/' + object.id, {status: 'published', change_log: this.change_log, master: masterObject}).then(function(response) {
            self.loadDocuments(self.currentPage);
            self.loadChildDocuments();
            self.hidePublishDocumentModal();
            self.$toastr('success', self.$t('maintenance.third_parties.documents.update_success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.publish_error = this.$t('maintenance.policies.documents.publish_error')
        }

      },
      showConfirmEditModeModal(object) {
        this.itemToChangeStatus = object
        this.$refs['confirm-edit-mode'].show()
      },
      hideConfirmEditModeModal() {
        this.itemToChangeStatus = {}
        this.$refs['confirm-edit-mode'].hide()
      },
      showPublishDocumentModal(object) {
        this.change_log = ''
        this.publish_error = ''
        this.$refs['publish-document'].show()
      },
      hidePublishDocumentModal() {
        this.publish_error = ''
        this.$refs['publish-document'].hide()
      },
      setEditModeDocument(object) {
        let self = this;
        let masterObject = {}

        if (this.selectedItem.latest_version.master && this.selectedItem.latest_version.master.id) {
          if (this.selectedItem.latest_version.master.who_am_i == 'App\\Maintenance\\Links\\Models\\Link') {
            masterObject = {type: 'link', id: this.selectedItem.latest_version.master.id}
          }
          if (this.selectedItem.latest_version.master.who_am_i == 'App\\Maintenance\\Document\\Models\\Document') {
            masterObject = {type: 'document', id: this.selectedItem.latest_version.master.id}
          }
        }

        piincHttp.put('/policies/' + this.policy.slug + '/documents/' + object.id, {status: 'edit_mode', master: masterObject}).then(function(response) {
          self.loadDocuments(self.currentPage);
          self.loadChildDocuments();
          self.hideConfirmEditModeModal()
          self.$toastr('success', self.$t('maintenance.third_parties.documents.update_success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      loadContent() {
        let self = this;
        piincHttp.get('policies/' + this.policy.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.policy = response.data;
        }, function() {});
      },
      loadDocuments(page, perPage) {

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;

        piincHttp.get('policies/' + this.policy.slug + '/documents', { params:
            {
              page: pageNumber,
              per_page: perPageNumber,
              sort: this.selectedSort !== '' ? this.selectedSort : undefined,
              order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
              keyword: this.keywordValue !== '' ? this.keywordValue : undefined,
              client: this.getClient.slug
            }
        }).then(function(response) {

          self.measureLoading = false;
          self.documentTableItems = response.data.items;
          // Set number of total items
          self.totalRows = response.data.total_count;

          if (self.selectedItem && self.selectedItem.id) {
            self.selectedItem = _.find(self.documentTableItems, function(object) {
              return object.id == self.selectedItem.id
            });
          }
        }, function() {});
      },
      loadChildDocuments() {
        let self = this;

        piincHttp.get('policies/' + this.policy.slug + '/documents', { params:
          {
            policy_document_id: this.selectedItem.id,
            per_page: 100,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
            keyword: this.keywordValue !== '' ? this.keywordValue : undefined,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.measureLoading = false;
          self.documentSingleTableItems = response.data.items;
        }, function() {});
      },
      loadCategories(query) {
        let self = this;
        piincHttp.get('/policies/documents/categories', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.categoryItems = response.data
          if (self.categoryItems && !self.categoryItems.length && !query) {
            self.categoryItems.push({category: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      pageChanged(page) {
        // Load Third parties when page changed listener is triggered
        this.loadDocuments(page)
      },
      perPageChanged(perPage) {
        let self = this;

        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
        // Load Third parties when page changed listener is triggered
        this.loadDocuments(1, perPage.value)
      },
      perPageRemoved() {
        let self = this;
        // Load Third parties when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadDocuments(1, self.selectedPerPage)

      },
    },
    created () {
      this.policy = this.object
      if (this.getClient && this.getClient.slug) {
        this.loadCategories();
      }

      if (this.policy && this.policy.slug) {
        // Table items
        this.loadDocuments();
        this.loadTasks('update_documents');
      }

      this.loadGuides('update_documents')
    }
  }
</script>
